export default {"src":"/_next/static/media/Monday.4c771321.svg","height":1398,"width":842};